// extracted by mini-css-extract-plugin
export default {"mobile-row":"CompanySelector_mobile-row__m9-0t","saveButton":"CompanySelector_saveButton__OMmyZ"};